import Acknowledgement from './Acknowledgement';
import { CreditApplicationType } from 'src/utils/enums/financialTypes.enum';
import DealerAcknowledgement from './DealerAcknowledgement';
import Footer from './Footer';
import FormSectionPage from '../../ui/formSectionPage';
import { isSiteCanadian } from 'src/utils/helpers';
import { IUser } from '../../../../utils/interfaces/user';
import Notes from './Notes';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';

interface IOtherInfoProps {
    applicationType: string;
    setOthernData: Function;
    setCootherData: Function;
    setOtherValid: Function;
    isOpen: boolean;
    setOpen: Function;
    isBlocked?: boolean;
    initialPrimaryApplicant?: any;
    initialJointOrCoApplicant?: any;
    initialNotes?: any;
    initialBusinessApp?: any;
    isPrimaryQuebec?: boolean;
    isSecondaryQuebec?: boolean;
    isEditMode?: boolean;
    disablePrintAndSubmitBtn: Function;
}

export interface IOtherInfo {
    primaryPipedaConsent: boolean;
    primaryCaslConsent: boolean;
    notes: string;
    secondaryPipedaConsent?: boolean;
    secondaryCaslConsent?: boolean;
    primaryCreditAssessmentConset?: boolean;
    secondaryCreditAssessmentConsent?: boolean;
    primaryAccountMonitoringConsent?: boolean;
    primaryQuebecAssessment?: boolean;
    primaryQuebecContract?: boolean;
    secondaryQuebecAssessment?: boolean;
    secondaryQuebecContract?: boolean;
}

const OtherInformation: React.FC<IOtherInfoProps> = ({
    applicationType,
    setOthernData,
    setCootherData,
    setOtherValid,
    isOpen,
    setOpen,
    isBlocked = false,
    initialPrimaryApplicant = null,
    initialJointOrCoApplicant = null,
    initialNotes = null,
    initialBusinessApp = null,
    isPrimaryQuebec = false,
    isSecondaryQuebec = false,
    isEditMode = false,
    disablePrintAndSubmitBtn,
}) => {
    const { creditAppOtherInformation } = useLocalization();
    const currentBrand = useSelector((state: IUser) => {
        return state.dealerDataInfo?.dealer.brand || 'VW';
    });

    const [disabledForm, setDisabledForm] = useState<boolean>(false);
    const [isConsentAndNotesUpdated, setIsConsentAndNotesUpdated] =
        useState<boolean>(false);

    const [validated, setValidated] = useState<boolean | null>(null);
    //const [isOpen, setOpen] = useState<boolean>(false);

    const [noteValue, setNoteValue] = useState<string>('');
    const [primaryPipeda, setPrimaryPipeda] = useState<boolean>(true);
    const [isErrorPrimaryPipeda, setIsErrorPrimaryPipeda] =
        useState<boolean>(false);
    const [primaryContactValue, setPrimaryContactValue] =
        useState<boolean>(false);
    const [isErrorPrimaryContact, setIsErrorPrimaryContact] =
        useState<boolean>(false);
    const [secondaryPipeda, setSecondaryPipeda] = useState<boolean>(false);
    const [isErrorSecondaryPipeda, setIsErrorSecondaryPipeda] =
        useState<boolean>(false);
    const [secondaryContactValue, setSecondaryContactValue] =
        useState<boolean>(false);
    const [isErrorSecondaryContact, setIsErrorSecondaryContact] =
        useState<boolean>(false);
    const [primaryQuebecContract, setPrimaryQuebecContract] =
        useState<boolean>(false);
    const [isErrorPrimaryQuebecContract, setIsErrorPrimaryQuebecContract] =
        useState<boolean>(false);
    const [primaryQuebecAssessment, setPrimaryQuebecAssessment] =
        useState<boolean>(false);
    const [isErrorPrimaryQuebecAssessment, setIsErrorPrimaryQuebecAssessment] =
        useState<boolean>(false);
    const [secondaryQuebecContract, setSecondaryQuebecContract] =
        useState<boolean>(false);
    const [isErrorSecondaryQuebecContract, setIsErrorSecondaryQuebecContract] =
        useState<boolean>(false);
    const [secondaryQuebecAssessment, setSecondaryQuebecAssessment] =
        useState<boolean>(false);
    const [
        isErrorSecondaryQuebecAssessment,
        setIsErrorSecondaryQuebecAssessment,
    ] = useState<boolean>(false);

    const setApplicantConsents = () => {
        setPrimaryPipeda(
            initialPrimaryApplicant?.Consent?.NppiSharingConsentGiven ===
                'True',
        );
        setPrimaryContactValue(
            initialPrimaryApplicant?.Consent?.ECommConsentGiven === 'True',
        );
        setSecondaryPipeda(
            initialJointOrCoApplicant?.Consent?.NppiSharingConsentGiven ===
                'True',
        );
        setSecondaryContactValue(
            initialJointOrCoApplicant?.Consent?.ECommConsentGiven === 'True',
        );
        setPrimaryQuebecAssessment(
            initialPrimaryApplicant?.Consent?.CreditAssessmentConsentGiven ===
                'True',
        );
        setPrimaryQuebecContract(
            initialPrimaryApplicant?.Consent?.AccountMonitoringConsentGiven ===
                'True',
        );
        setSecondaryQuebecAssessment(
            initialJointOrCoApplicant?.Consent?.CreditAssessmentConsentGiven ===
                'True',
        );
        setSecondaryQuebecContract(
            initialJointOrCoApplicant?.Consent
                ?.AccountMonitoringConsentGiven === 'True',
        );
    };

    //for edit mode
    useEffect(() => {
        if (
            !initialPrimaryApplicant &&
            !initialJointOrCoApplicant &&
            !initialBusinessApp
        ) {
            resetValues();
            return;
        }

        setNoteValue(initialNotes ?? '');

        if (initialPrimaryApplicant || initialJointOrCoApplicant) {
            setApplicantConsents();
        }

        if (initialBusinessApp) {
            setPrimaryPipeda(
                initialBusinessApp?.Consent?.NppiSharingConsentGiven === 'True',
            );
            setPrimaryContactValue(
                initialBusinessApp?.Consent?.ECommConsentGiven === 'True',
            );
            setNoteValue(initialNotes ?? '');
        }
        setIsConsentAndNotesUpdated(true);
    }, [applicationType]);

    const onEdit = () => {
        setDisabledForm(false);
        setOtherValid(false);
        if (isEditMode) {
            disablePrintAndSubmitBtn(true);
        }
    };

    const setSectionData = (otherInfoObject: IOtherInfo, notes: any) => {
        let primary = {
            primaryPipedaConsent: otherInfoObject.primaryPipedaConsent,
            primaryCaslConsent: otherInfoObject.primaryCaslConsent,
            notes,
        };

        if (
            (isPrimaryQuebec || isSecondaryQuebec) &&
            primaryQuebecAssessment &&
            primaryQuebecContract
        ) {
            primary = setAssessment(primary, true);
        }

        setOthernData({ ...primary });

        if (shouldShowSecondary()) {
            let coop = {
                primaryPipedaConsent: otherInfoObject.secondaryPipedaConsent,
                primaryCaslConsent: otherInfoObject.secondaryCaslConsent,
            };
            if (
                (isPrimaryQuebec || isSecondaryQuebec) &&
                secondaryQuebecAssessment &&
                secondaryQuebecContract
            ) {
                coop = setAssessment(coop);
            }
            setCootherData({ ...coop });
        }
    };

    function handlerSubmit() {
        clearErrors();
        let isValid = true;
        const otherInfoObject: IOtherInfo = {
            primaryPipedaConsent: primaryPipeda,
            primaryCaslConsent: primaryContactValue,
            notes: noteValue,
        };
        if (
            (isPrimaryQuebec || isSecondaryQuebec) &&
            !primaryQuebecAssessment
        ) {
            setIsErrorPrimaryQuebecAssessment(true);
            isValid = false;
        }
        if ((isPrimaryQuebec || isSecondaryQuebec) && !primaryQuebecContract) {
            setIsErrorPrimaryQuebecContract(true);
            isValid = false;
        }
        if (shouldShowSecondary()) {
            if (
                (isPrimaryQuebec || isSecondaryQuebec) &&
                !secondaryQuebecAssessment
            ) {
                setIsErrorSecondaryQuebecAssessment(true);
                isValid = false;
            }
            if (
                (isPrimaryQuebec || isSecondaryQuebec) &&
                !secondaryQuebecContract
            ) {
                setIsErrorSecondaryQuebecContract(true);
                isValid = false;
            }
            otherInfoObject.secondaryPipedaConsent = secondaryPipeda;
            otherInfoObject.secondaryCaslConsent = secondaryContactValue;
        }

        let notes;

        if (otherInfoObject.notes) {
            notes = otherInfoObject.notes;
        }

        if (isValid) {
            setSectionData(otherInfoObject, notes);
            setDisabledForm(true);
            setOtherValid(true);
        }
        setValidated(isValid);
        setOpen(!isValid);
    }

    function setAssessment(value: any, main = false) {
        return {
            ...value,
            quebecAssessment: main
                ? primaryQuebecAssessment
                : secondaryQuebecAssessment,
            quebecContract: main
                ? primaryQuebecContract
                : secondaryQuebecContract,
        };
    }

    function clearErrors() {
        setIsErrorSecondaryPipeda(false);
        setIsErrorSecondaryContact(false);
        setIsErrorPrimaryPipeda(false);
        setIsErrorPrimaryContact(false);
        setIsErrorPrimaryQuebecAssessment(false);
        setIsErrorPrimaryQuebecContract(false);
        setIsErrorSecondaryQuebecAssessment(false);
        setIsErrorSecondaryQuebecContract(false);
    }

    function resetValues() {
        clearErrors();
        setOpen(false);
        setValidated(null);
        setNoteValue('');
        setPrimaryPipeda(false);
        setPrimaryContactValue(false);
        setSecondaryContactValue(false);
        setSecondaryPipeda(false);
        setPrimaryQuebecAssessment(false);
        setPrimaryQuebecContract(false);
        setSecondaryQuebecAssessment(false);
        setSecondaryQuebecContract(false);
    }

    function shouldShowSecondary() {
        return (
            applicationType === CreditApplicationType.JOINT ||
            applicationType === CreditApplicationType.COAPP ||
            applicationType === CreditApplicationType.BUSINESS_COAPP ||
            applicationType === CreditApplicationType.BUSINESS_PG
        );
    }

    function buildAndSetOtherInformation() {
        const otherInfoObject: IOtherInfo = {
            primaryPipedaConsent: primaryPipeda,
            primaryCaslConsent: primaryContactValue,
            notes: noteValue,
        };
        if (shouldShowSecondary()) {
            otherInfoObject.secondaryPipedaConsent = secondaryPipeda;
            otherInfoObject.secondaryCaslConsent = secondaryContactValue;
        }
        let notes;
        if (otherInfoObject.notes) {
            notes = otherInfoObject.notes;
        }
        setSectionData(otherInfoObject, notes);
    }

    useEffect(() => {
        if (isEditMode && isConsentAndNotesUpdated) {
            buildAndSetOtherInformation();
        }
    }, [
        isEditMode,
        isConsentAndNotesUpdated,
        isPrimaryQuebec,
        isSecondaryQuebec,
    ]);

    return (
        <FormSectionPage
            title={creditAppOtherInformation.TITLE}
            handlerSubmit={handlerSubmit}
            showIcon={validated}
            isOpen={isOpen}
            setOpen={setOpen}
            isDisabled={disabledForm}
            onEdit={onEdit}
            isEditMode={isEditMode}
            isBlocked={isBlocked}
            disablePrintAndSubmitBtn={disablePrintAndSubmitBtn}
        >
            <fieldset disabled={disabledForm}>
                {isSiteCanadian() ? (
                    <>
                        <Acknowledgement
                            applicant={'Primary'}
                            applicationType={applicationType}
                            brand={currentBrand}
                            pipedaValue={primaryPipeda}
                            setPipedaValue={setPrimaryPipeda}
                            isErrorPipeda={isErrorPrimaryPipeda}
                            contactValue={primaryContactValue}
                            setContactValue={setPrimaryContactValue}
                            isErrorContact={isErrorPrimaryContact}
                            isQuebec={isPrimaryQuebec || isSecondaryQuebec}
                            quebecContract={primaryQuebecContract}
                            setQuebecContract={setPrimaryQuebecContract}
                            isErrorQuebecContract={isErrorPrimaryQuebecContract}
                            quebecAssessment={primaryQuebecAssessment}
                            setQuebecAssessment={setPrimaryQuebecAssessment}
                            isErrorQuebecAssessment={
                                isErrorPrimaryQuebecAssessment
                            }
                        />
                        {shouldShowSecondary() ? (
                            <>
                                <hr />
                                <Acknowledgement
                                    applicant={'Secondary'}
                                    applicationType={applicationType}
                                    brand={currentBrand}
                                    pipedaValue={secondaryPipeda}
                                    setPipedaValue={setSecondaryPipeda}
                                    isErrorPipeda={isErrorSecondaryPipeda}
                                    contactValue={secondaryContactValue}
                                    setContactValue={setSecondaryContactValue}
                                    isErrorContact={isErrorSecondaryContact}
                                    isQuebec={
                                        isPrimaryQuebec || isSecondaryQuebec
                                    }
                                    quebecContract={secondaryQuebecContract}
                                    setQuebecContract={
                                        setSecondaryQuebecContract
                                    }
                                    isErrorQuebecContract={
                                        isErrorSecondaryQuebecContract
                                    }
                                    quebecAssessment={secondaryQuebecAssessment}
                                    setQuebecAssessment={
                                        setSecondaryQuebecAssessment
                                    }
                                    isErrorQuebecAssessment={
                                        isErrorSecondaryQuebecAssessment
                                    }
                                />
                            </>
                        ) : null}
                        <hr />
                    </>
                ) : null}
                <Notes content={noteValue} setContent={setNoteValue} />
                <DealerAcknowledgement />
                <Footer />
            </fieldset>
        </FormSectionPage>
    );
};

export default OtherInformation;
